import { c as _c } from "react/compiler-runtime";
import { SkeletonBar } from '@petsmart-ui/sparky';
import './Loading.scss';
export const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="loading-wrapper"><SkeletonBar className="skeleton" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};